import React, { Component } from "react"
// import PlaceImage from "./PlaceImage"
import PlaceImage from "../images/Partners-section.png"

export default class BannerPlace extends Component {
  render() {
    return (
      <>
        <section id="banner_place" className="banner_place">
          <div className="container mx-auto banner_place_header lg:px-0 px-8">
            <p className="heading lg:text-6xl text-5xl">
              <strong>Exclusive offers</strong> at{" "}
              <strong>
                100+ <br />
                stores&nbsp;
              </strong>
              in the <strong>city</strong>
            </p>
          </div>
        </section>
        <div
          className="banner_image"
          style={{ backgroundImage: `url(${PlaceImage})` }}
        ></div>
      </>
    )
  }
}
